import { render, staticRenderFns } from "./SincronizarUsuarios.vue?vue&type=template&id=c2ea6b80&scoped=true"
import script from "./SincronizarUsuarios.vue?vue&type=script&lang=js"
export * from "./SincronizarUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ea6b80",
  null
  
)

export default component.exports